import React from 'react';
import PropTypes from 'prop-types';
import {MenuItem} from 'material-ui/Menu';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';
import Typography from 'material-ui/Typography';
import Toolbar from 'material-ui/Toolbar';
import withStyles from 'material-ui/styles/withStyles';
import TextField from '../../common/form/text-field/index';
import FileField from '../../common/form/file-field/index';
import {FormHelperText} from 'material-ui/Form';
import {FILE_TYPE_PDF, FILE_TYPE_VIDEO, POSTER_TYPE, getMimeType} from '../../../common/types';

const styles = theme => ({
	root: {
		margin: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 24}px`
	},
	title: {
		marginBottom: theme.spacing.unit
	},
	form: {
		padding: `${theme.spacing.unit}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`
	},
	formActions: {
		marginTop: theme.spacing.unit * 3
	}
});

function getAcceptError(type) {
	const errors = {
		[FILE_TYPE_PDF]: 'Pick a PDF file',
		[FILE_TYPE_VIDEO]: 'Pick a video file',
		[POSTER_TYPE]: 'Pick an image file'
	};

	return errors[type] || 'Pick an appropriate file';
}

const AdminFileDetails = props => {
	const {
		classes,
		formTitle,
		submitLabel,
		handleCancel,
		handleSubmit,
		setFieldValue,
		setFieldTouched,
		setFieldError,
		dropMediaValue,
		values,
		errors,
		touched,
		status,
		parentId
	} = props;

	const textFieldProps = {
		setFieldValue,
		setFieldTouched,
		setFieldError,
		values,
		errors,
		touched,
		className: classes.formControl
	};

	function isVideo() {
		return values.type === FILE_TYPE_VIDEO;
	}

	const formHelperText = status.failed ?
		'Something went wrong. Refresh page and try again later' :
		'';

	const posterHelperText = isVideo() ?
		'Drag and drop a file here or youtube preview image will be used' :
		'Drag and drop a file here';

	return (
		<div className={classes.root}>
			<Toolbar className={classes.title}>
				<Typography type="display2">
					{formTitle}
				</Typography>
			</Toolbar>
			<Paper className={classes.form}>
				<form onSubmit={handleSubmit} autoComplete="off">
					<TextField
						margin="normal"
						fullWidth
						label="Title"
						name="name"
						{...textFieldProps}
					/>
					<TextField
						margin="normal"
						fullWidth
						multiline
						label="Description"
						name="description"
						{...textFieldProps}
					/>
					<TextField
						margin="normal"
						label="Sort order"
						name="sortOrder"
						{...textFieldProps}
					/>
					<br/>
					<TextField
						margin="normal"
						label="Type"
						name="type"
						select
						valueChangeListener={dropMediaValue}
						{...textFieldProps}
					>
						<MenuItem value={FILE_TYPE_PDF}>PDF</MenuItem>
						<MenuItem value={FILE_TYPE_VIDEO}>Video</MenuItem>
					</TextField>
					<FileField
						parentId={parentId}
						margin="normal"
						fullWidth
						label="Thumbnail"
						name="poster"
						accept={getMimeType(POSTER_TYPE)}
						acceptError="Pick an image file"
						helperText={posterHelperText}
						compression
						{...textFieldProps}
					/>
					<FileField
						parentId={parentId}
						margin="normal"
						fullWidth
						label="File"
						name="media"
						accept={getMimeType(values.type)}
						acceptError={getAcceptError(values.type)}
						helperText="Drag and drop a file here"
						{...textFieldProps}
					/>
					{isVideo() && (
						<TextField
							fullWidth
							margin="normal"
							label="YouTube URL"
							name="streaming"
							{...textFieldProps}
						/>
					)}
					<div className={classes.formActions}>
						<Button raised color="primary" type="submit" disabled={status.pending}>
							{submitLabel}
						</Button>
						<Button onClick={handleCancel}>
							Cancel
						</Button>
					</div>
					{formHelperText && (
						<FormHelperText error={status.failed}>
							{formHelperText}
						</FormHelperText>
					)}
				</form>
			</Paper>
		</div>
	);
};

AdminFileDetails.propTypes = {
	classes: PropTypes.object.isRequired,
	formTitle: PropTypes.string.isRequired,
	submitLabel: PropTypes.string.isRequired,
	handleCancel: PropTypes.func.isRequired,
	handleSubmit: PropTypes.func.isRequired,
	setFieldValue: PropTypes.func.isRequired,
	setFieldTouched: PropTypes.func.isRequired,
	setFieldError: PropTypes.func.isRequired,
	dropMediaValue: PropTypes.func.isRequired,
	values: PropTypes.object.isRequired,
	errors: PropTypes.object.isRequired,
	touched: PropTypes.object.isRequired,
	status: PropTypes.object.isRequired,
	parentId: PropTypes.string.isRequired
};

export default withStyles(styles)(AdminFileDetails);



// WEBPACK FOOTER //
// ./src/client/components/admin/files/details/form.jsx